document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-warranty-video-media]').forEach(function (media) {
    var playBtn = media.querySelector('[data-warranty-video-play]');
    var videoPlayer = media.querySelector('[data-warranty-video-player]');

    if (!playBtn || !videoPlayer) return;

    var PLAY_LABEL = playBtn.dataset.labelPlay || 'Play video';
    var PAUSE_LABEL = playBtn.dataset.labelPause || 'Pause video';

    function setPlaying(isPlaying) {
      media.classList.toggle('is-playing', isPlaying);
      playBtn.setAttribute('aria-label', isPlaying ? PAUSE_LABEL : PLAY_LABEL);
    }

    function play() {
      media.classList.add('has-started');
      setPlaying(true);

      if (videoPlayer.ended) {
        videoPlayer.currentTime = 0;
      }

      var playPromise = videoPlayer.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          setPlaying(false);
        });
      }
    }

    function pause() {
      setPlaying(false);
      videoPlayer.pause();
    }

    function toggle() {
      if (media.classList.contains('is-playing')) {
        pause();
      } else {
        play();
      }
    }

    playBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      toggle();
    });

    media.addEventListener('click', function () {
      if (!media.classList.contains('has-started')) return;
      toggle();
    });

    // Keep the UI in sync when playback changes outside the button (media keys, PiP, OS or tab pauses, end of video).
    videoPlayer.addEventListener('play', function () {
      media.classList.add('has-started');
      setPlaying(true);
    });

    videoPlayer.addEventListener('pause', function () {
      setPlaying(false);
    });
  });
});
